import React, { useState, useEffect, useRef } from "react";
import Form from "react-bootstrap/Form";
import ToastContainerComponent from "../toast/toast.component";
import Popup from "../../components/popup-modal/popup.component";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectUserLoading } from "../../redux/user/user.selector";
import { setUserLoader } from "../../redux/user/user.actions";
import { putRequest } from "../../utils/apiCallerUtil";
import { toastErrorMessagePopUp } from "../../utils/toastMessagePopup";
import SimpleReactValidator from "simple-react-validator";
import "./editProfile.styles.scss";

const EditProfile = (props) => {
  // state for user credentials to login
  const [userCredentials, setCredentials] = useState({
    password: "",
    confirmPassword: "",
  });

  const { password, confirmPassword } = userCredentials;

  const handleCloseComponent = (message) => {
    //   calls closeComponent method from props to close the modal also passes the success message
    props.closeComponent(message);
  };

  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();

  const stopSpinner = () => {
    props.setUserLoader(false);
  };

  useEffect(() => {
    return () => {
      stopSpinner();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    forceUpdate();
  }, [password, confirmPassword]);

  const handleInputChange = (event) => {
    //   handles the password and confirmPassword and saves them to useState
    const { value, name } = event.target;
    setCredentials({ ...userCredentials, [name]: value });
  };

  const handleSubmitUser = async (event) => {
    // handle submit function
    event.preventDefault();
    if (simpleValidator.current.allValid() && password === confirmPassword) {
      //   starts the spinner
      props.setUserLoader(true);
      // sets the passwordObject to be send
      let passwordObject = {
        password: password,
        rpassword: confirmPassword,
        passwordonly: true,
      };
      //   axios call to change the password

      let response = await putRequest("profile/edit", { data: passwordObject });
      if (response.status >= 200 && response.status < 300) {
        // if everything okay then the close component get called
        handleCloseComponent(response.data.message);
      } else {
        // if error arises then it displays a toast error message popup
        toastErrorMessagePopUp(response.data.detail);
      }
      //  spinner stops
      stopSpinner();
    } else {
      forceUpdate(1);
      simpleValidator.current.showMessages();
    }
  };

  return (
    <Popup
      popupBig={true}
      // pass true for 1000px width popup or false for 800px width popup
      dualTitle={false}
      // pass true if there are two titles (blue and black) or false if only one title in black
      modalTitle="Edit Profile"
      // 1st title which is the default and gest used first
      modalTitle2={""}
      // 2nd title required to pass if only dualTitle is true, for 2nd title
      closeComponent={handleCloseComponent}
      // function called to close the popup component
      cancelButtonVisible={true}
      // cancel button visible in footer if true, if false then cancel button is not shown
      saveButtonVisible={true}
      // save button visible in footer if true, if false then save button is not shown
      saveComponent={handleSubmitUser}
      // note : if both cancel button and save button visible is false then the footer
      // will not be loaded , only the header and body will be visible
      saveButtonText="Save"
      // save button text
      saveButtonDisable={password === "" || confirmPassword === "" || props.userLoader}
      // to disable save button
      spinnerVisible={props.userLoader}
    // for spinner visibility after save button
    >
      <Form>
        <Form.Group>
          <Form.Label className="edit-profile-form-label-password">
            Change Your Password
            </Form.Label>
          <Form.Control
            id="form-ctrl-password"
            type="password"
            onChange={(event) => handleInputChange(event)}
            placeholder="New Password"
            name="password"
            value={password}
            onBlur={() => {
              simpleValidator.current.showMessageFor("password");
              forceUpdate(1);
            }}
          />
          {/* Here are the alert messages */}
          <span className="edit-profile-show-alert">
            {simpleValidator.current.message(
              "password",
              password,
              "required|string|min:8"
            )}
          </span>
        </Form.Group>
        <Form.Group>
          <Form.Control
            autoComplete="off"
            id="form-ctrl-conformpassword"
            type="password"
            name="confirmPassword"
            onChange={(event) => handleInputChange(event)}
            placeholder="Confirm Password"
            value={confirmPassword}
            onBlur={() => {
              simpleValidator.current.showMessageFor("confirmPassword");
              forceUpdate(1);
            }}
          />
          {/* Here are the alert messages */}
          <span className="edit-profile-show-alert">
            {simpleValidator.current.message(
              "confirmPassword",
              confirmPassword,
              "required|string|min:8"
            )}
          </span>
          <span className="edit-profile-show-alert">
            {simpleValidator.current.fieldValid("confirmPassword") ? (
              password !== confirmPassword ? (
                <span>Confirm password should match with password</span>
              ) : null
            ) : null}
          </span>
        </Form.Group>
      </Form>
      <ToastContainerComponent />
    </Popup>
  );
};

const mapStateToProps = createStructuredSelector({
  // maps mfa status from redux store to props
  userLoader: selectUserLoading,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setUserLoader: (status) => dispatch(setUserLoader(status)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditProfile);
